import React, { useEffect, useRef, useCallback } from "react"
import onScan from "onscan.js"

const BarcodeScanner = ({ barcode, setBarcode }) => {
  const barcodeSearchRef = useRef(null)

  const handleSearch = useCallback((searchTerm) => {
    console.log("searchTerm-handlesearch", searchTerm)
    setBarcode(searchTerm)
  }, [setBarcode]);

  useEffect(() => {
    const keyCodeMap = {
      189: "-",
      173: "-",
      190: ".",
      188: ",",
      191: "/",
      186: ";",
      222: "'",
      219: "[",
      221: "]",
      220: "\\",
      187: "=",
      192: "~",
      223: "`"
    }
    onScan.attachTo(document, {
      onScan: (scannedCode) => {
        if (scannedCode) {
          barcodeSearchRef?.current?.focus()
          handleSearch(scannedCode)
        }
      },
      keyCodeMapper: function (event) {
        const keyCode = event.which || event.keyCode
        if (Object.keys(keyCodeMap).includes(String(keyCode))) {
          return keyCodeMap[keyCode]
        }
        return onScan.decodeKeyEvent(event)
      }
    })

    return () => {
      onScan.detachFrom(document)
    }
  }, [handleSearch])


  const handlePaste = (e) => {
    const searchValue = e?.clipboardData?.getData("text")
    setTimeout(() => {
      console.log("searchValue", searchValue)
    }, 200)
  }

  const handleChange = (searchTerm) => {
    console.log("search-handlechange", searchTerm)
  }

  return (
    <input
      label="Barcode Search"
      placeholder="Barcode"
      disabled
      value={barcode}
      setSearchValue={handleChange}
      searchInputRef={barcodeSearchRef}
      onEnter={handleSearch}
      onPaste={handlePaste}
      style={{
        padding: "12px",
        fontsize: "24px",
        fontWeight: 600,
        borderRadius: "6px"
      }}
    />
  )
}

export default BarcodeScanner
